import React, { FC } from 'react';
import { Box, FormControlLabel, FormGroup, Radio, RadioGroup } from '@mui/material';

interface Props {
  question: any;
  step: number;
  onChange: (qid: string, val: string, i: number, p: boolean) => Promise<void>;
  value?: string;
}

const CustomQuestionSingle: FC<Props> = ({ question, step, onChange, value }) => {
  const optionClick = async (e: any, option: any) => {
    if (e.target.value === undefined) {
      return;
    }
    if (option.label === value) {
      await onChange(question.questionId || '', '', step, false);
    } else {
      await onChange(question.questionId || '', option.label, step, false);
    }
  };

  return (
    <Box>
      <FormGroup>
        <RadioGroup>
          {question.options.map((option: any, index: any) => (
            <FormControlLabel
              key={question.questionId + '|' + index}
              control={<Radio checked={option.label === value} />}
              label={option.label}
              value={option.label}
              onClick={(e) => optionClick(e, option)}
            />
          ))}
        </RadioGroup>
      </FormGroup>
    </Box>
  );
};

export default CustomQuestionSingle;
